import React, { useEffect } from "react";
import { IoMdQuote } from "react-icons/io";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PrimeSlides = () => {
  // ================= Card Slider start here ===================
  useEffect(() => {
    let cards = document.querySelector(".cards");
    const prevbtn = document.querySelector(".prevbtn");
    const nextbtn = document.querySelector(".nextbtn");
    cards.style.transform = "translateX(0)";
    cards.style.transition = "all ease-in-out .4s";
    prevbtn.addEventListener("click", () => {
      if (cards.style.transform === "translateX(0px)") {
        cards.style.transform = "translateX(-920px)";
      } else {
        if (cards.style.transform === "translateX(-920px)") {
          cards.style.transform = "translateX(-460px)";
        } else if (cards.style.transform === "translateX(-460px)") {
          cards.style.transform = "translateX(0)";
        }
      }
    });
    nextbtn.addEventListener("click", () => {
      if (cards.style.transform === "translateX(0px)") {
        cards.style.transform = "translateX(-460px)";
      } else if (cards.style.transform === "translateX(-460px)") {
        cards.style.transform = "translateX(-920px)";
      } else {
        cards.style.transform = "translateX(0)";
      }
    });
  }, []);
  // ================= Card Slider end here =====================

  return (
    <div className="w-full pt-14 pb-24">
      <div className="max-w-screen-2xl px-2 mx-auto relative group overflow-hidden group">
        <div className="flex flex-row items-center justify-start py-6 px-6 gap-10 cards translate-x-0">
          <div className="min-w-[420px] md:h-66 rounded-md border border-gray-300 p-6 flex flex-col gap-6 shadow-md shadow-primeColor hover:shadow-darkPink duration-300 card">
            <div className="flex flex-col gap-2">
              <span>
                <IoMdQuote className="text-5xl text-gray-300" />
              </span>
              <p className="text-[16px] font-bodyFont text-gray-500">
                I gave my mock test. You guys were a great help. I have also
                improved a lot - Thank you so much for your support.
              </p>
            </div>
            <div>
              <h2 className="text-xl text-gray-700 font-semibold font-titleFont">
                Umme Salma Rumana
              </h2>
              <p className="text-[16px] font-bodyFont text-gray-400">
                South East University
              </p>
            </div>
          </div>
          <div className="min-w-[420px] md:h-66 rounded-md border border-gray-300 p-6 flex flex-col gap-6 shadow-md shadow-primeColor hover:shadow-darkPink duration-300 card ">
            <div className="flex flex-col gap-2">
              <span>
                <IoMdQuote className="text-5xl text-gray-300" />
              </span>
              <p className="text-[16px] font-bodyFont text-gray-500">
                Thanks, educare for the support. Really appreciate your
                professionalism. I wish all the very best to educare and the
                entire team.
              </p>
            </div>
            <div>
              <h2 className="text-xl text-gray-700 font-semibold font-titleFont">
                Shahriar Anik
              </h2>
              <p className="text-[16px] font-bodyFont text-gray-400">
                Assistant Professor, Cumilla University
              </p>
            </div>
          </div>
          <div className="min-w-[420px] md:h-66 rounded-md border border-gray-300 p-6 flex flex-col gap-6 shadow-md shadow-primeColor hover:shadow-darkPink duration-300 card ">
            <div className="flex flex-col gap-2">
              <span>
                <IoMdQuote className="text-5xl text-gray-300" />
              </span>
              <p className="text-[16px] font-bodyFont text-gray-500">
                I have completed spoken English courses from EduCare English
                Learning Academy. The teachers are very helpful & cooperative.
              </p>
            </div>
            <div>
              <h2 className="text-xl text-gray-700 font-semibold font-titleFont">
                Nahida Akter Nodi
              </h2>
              <p className="text-[16px] font-bodyFont text-gray-400">
                Student, Hazrat Shah Ali Girls High School
              </p>
            </div>
          </div>
          <div className="min-w-[420px] md:h-66 rounded-md border border-gray-300 p-6 flex flex-col gap-6 shadow-md shadow-primeColor hover:shadow-darkPink duration-300 card">
            <div className="flex flex-col gap-2">
              <span>
                <IoMdQuote className="text-5xl text-gray-300" />
              </span>
              <p className="text-[16px] font-bodyFont text-gray-500">
                I have completed Spoken English courses from EduCare English
                Learning Academy. The teachers are very helpful & cooperative.
              </p>
            </div>
            <div>
              <h2 className="text-xl text-gray-700 font-semibold font-titleFont">
                MD Arif Hossain
              </h2>
              <p className="text-[16px] font-bodyFont text-gray-400">
                Graphics Designer, Fiverr.com
              </p>
            </div>
          </div>
          <div className="min-w-[420px] md:h-66 rounded-md border border-gray-300 p-6 flex flex-col gap-6 shadow-md shadow-primeColor hover:shadow-darkPink duration-300 card">
            <div className="flex flex-col gap-2">
              <span>
                <IoMdQuote className="text-5xl text-gray-300" />
              </span>
              <p className="text-[16px] font-bodyFont text-gray-500">
                Excellent, best online English learning academy. All teachers
                are helpful and the management is good.
              </p>
            </div>
            <div>
              <h2 className="text-xl text-gray-700 font-semibold font-titleFont">
                Imdad Tarek
              </h2>
              <p className="text-[16px] font-bodyFont text-gray-400">
                fiver.com
              </p>
            </div>
          </div>
        </div>

        <span className="absolute left-2 top-[45%] w-10 h-10 bg-primeColor text-white hidden group-hover:inline-flex text-xl rounded-full items-center justify-center text-center hover:bg-darkPink cursor-pointer transition-hover duration-300 prevbtn">
          <FaChevronLeft />
        </span>
        <span className="absolute right-2 top-[45%] w-10 h-10 bg-primeColor text-white hidden group-hover:inline-flex text-xl rounded-full items-center justify-center text-center hover:bg-darkPink cursor-pointer transition-hover duration-300 nextbtn">
          <FaChevronRight />
        </span>
      </div>
    </div>
  );
};

export default PrimeSlides;
